import React, { useRef, useState, useEffect } from "react";
import Webcam from "react-webcam";

const KycCapture = (props) => {
  const webcamRef = useRef(null);
  const [image, setImage] = useState(null);
  const [hasCameraAccess, setHasCameraAccess] = useState(null);
  const [cameraError, setCameraError] = useState("");

  const checkCameraAccess = () => {
    setHasCameraAccess(null); // Reset while checking
    setCameraError(""); // Clear any previous error

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        setHasCameraAccess(true);
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((err) => {
        console.error("Camera access error:", err);
        setHasCameraAccess(false);
        setCameraError(err.message || "Camera access denied");
      });
  };

  useEffect(() => {
    checkCameraAccess();
  }, []);

  const handleRetry = () => {
    checkCameraAccess();
  };

  const capture = () => {
    const screenshot = webcamRef.current.getScreenshot();
    setImage(screenshot);
    props.myPhotoUpload(screenshot);
  };

  const Recapture = () => {    
    setImage(null);
    props.myPhotoUpload(null);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h2>Please See Here</h2>

      {hasCameraAccess === null ? (
        <p>🔍 Checking camera access...</p>
      ) : !hasCameraAccess ? (
        <div style={{ color: "red" }}>
          <p>🚫 Cannot access camera:</p>
          <p>{cameraError}</p>
          <p>Please allow camera permissions and click Retry.</p>
          <button onClick={handleRetry} className="upload-btn">
            🔁 Retry
          </button>
        </div>
      ) : (
        <>
          {!image ? (
            <div style={{ position: "relative", display: "inline-block" }}>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  facingMode: "user",
                }}
                style={{
                  width: 400,
                  height: 400,
                  borderRadius: 8,
                  objectFit: "cover",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 250,
                  height: 300,
                  border: "4px solid #00bfff",
                  borderRadius: "50%",
                  boxSizing: "border-box",
                }}
              ></div>
            </div>
          ) : (
            <div className="selfie">
              <div className="selfiePhoto">
                <img
                  src={image}
                  alt="Captured"
                  style={{
                    width: 400,
                    height: 400,
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          )}

          <br />
          {!image ? (
            <button onClick={capture} className="upload-btn">
              📸 Capture
            </button>
          ) : (
            <button onClick={Recapture} className="upload-btn">
              🔄 Retake
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default KycCapture;